// Mirrors the retired coffee `EmotionalDial.Lib` (viewMode/lineMode option lists + defaults).
export const VIEW_MODE_OPTIONS = [
  { text: 'Windmap', value: 'windmap', listText: 'Windmap' },
  { text: 'Timeslice', value: 'timeslice', listText: 'Timeslice' },
  { text: 'Aggregated', value: 'aggregated', listText: 'Aggregated' }
]

export const LINE_MODE_OPTIONS = [
  { text: 'Precise', value: 'precise', listText: 'Precise' },
  { text: 'Smooth', value: 'smooth', listText: 'Smooth' },
  { text: 'Segmented', value: 'segmented', listText: 'Segmented' }
]

export const DEFAULT_OPTIONS = { lineMode: 'precise', viewMode: 'windmap', videoTime: 0 }

// The height the block draws its chart at. Fixed by the design, so the shell has nothing to say
// about it.
export const CHART_HEIGHT = 555
